<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="MenuBtnWrap">
        <div class="btn" @click="$router.push('/newsList')">返回新聞列表</div>
      </div>
      <div class="tableWrap">
        <el-table :data="newsList" height="660px" stripe style="width: 100%">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in newsListTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :show-overflow-tooltip="true"
            :min-width="item.minWidth"
          >
            <template slot-scope="scope">
              <div v-if="scope.row[item.prop]">
                {{ scope.row[item.prop] }}
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="250">
            <template slot-scope="scope">
              <el-button
                class="topBtn"
                @click="
                  editNews(scope.row.id, scope.row.type, scope.row.status)
                "
                type="text"
                >編輯
              </el-button>
              <el-button type="text" @click="delNews(scope.row.id)"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          :page-sizes="[20, 30]"
          :page-size="currentPageSize"
          :pager-count="5"
          layout="sizes,prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "新聞 / 新聞列表",
      navtitle: "草稿箱",
      listMenuForm: {
        startTime: "",
        endTime: "",
        keyword: "",
      },
      newsList: [],
      block: "0",
      newsListTable: [
        {
          prop: "title",
          label: "新聞名稱",
          width: "",
          minWidth: "200",
        },
        {
          prop: "block",
          label: "新聞版塊",
          width: "120",
        },
        {
          prop: "vip",
          label: "權限",
          width: "100",
        },
        {
          prop: "updateDate",
          label: "最後更新時間",
          width: "200",
        },
      ],
      total: 50,
      currentPageSize: 20,
      currentPage: 1,
      dialogVisible: false,
    };
  },
  created() {
    let _this = this;
    _this.initList();
  },
  // activated() {
  //   let _this = this;
  //   _this.initList();
  // },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    initList() {
      let _this = this;
      let param = {
        page: _this.currentPage,
        size: _this.currentPageSize,
        drafts: 0,
        type: 0,
      };
      _this
        .$post(
          "/request/article/getArticleList",
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            _this.newsList = res.data.list.forEach((v) => {
              //新聞版塊分類
              switch (v.type) {
                case 0:
                  v.block = "-";
                  v.vip = "非會員";
                  break;
                case 2:
                  v.block = "vlog";
                  v.vip = "會員";
                  v.blockStatus = 2;
                  break;
                case 3:
                  v.block = "小版工";
                  v.vip = "會員";
                  v.blockStatus = 3;
                  break;
                case 4:
                  v.block = "新聞";
                  v.vip = "非會員";
                  v.blockStatus = 4;
                  break;
                case 7:
                  v.block = "社群";
                  (v.vip = "非會員"), (v.blockStatus = 7);
                  break;
              }
              if (v.status === 1) {
                v.status = "已發佈";
              } else if (v.status === 2) {
                v.status = "待發佈";
              } else if (v.status === 3) {
                v.status = "已隐藏";
              }
            });
            _this.newsList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.initList();
    },
    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.initList();
    },
    // 刪除新聞
    delNews(id) {
      let _this = this;
      this.$confirm("是否刪除該草稿?", "提示信息", {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        center: true,
        closeOnClickModal: false,
      }).then(() => {
        // 确认删除的回调
        _this
          .$get(`/request/article/deleteNews/${id}`, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              if (_this.newsList.length == 1 && _this.currentPage > 1) {
                _this.currentPage--;
              }
              _this.$propMessage("刪除成功", "success", function () {
                _this.dialogVisible = false;
                _this.block = "";
                _this.initList();
              });
            } else {
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          });
      });
    },
    // 修改新闻
    editNews(id, type, status) {
      this.$get(`/request/article/getArticleDetail/${id}`).then((res) => {
        if (res.code === "00000") {
          this.$router.push(
            `/editNews?id=${id}&type=${type}&status=${
              status === "已發佈" ? 1 : status === "已隐藏" ? 3 : 0
            }&push=${res.data.push == 1 ? true : false}&pageType=draft`
          );
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>
<style lang="less" scoped>
.content {
  .paddingContent {
    .ListMenu {
      .MenuBtnWrap {
        display: flex;
        justify-content: flex-end;

        .btn:last-child {
          margin-left: 0.2rem;
        }
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }

  .topBtn {
    width: 50px;
  }
}

@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/news/draftNews.vue